// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountPage_container__20zkI","account":"AccountPage_account__27si9","row":"AccountPage_row__1LR04","col":"AccountPage_col__PcqCg","btns":"AccountPage_btns__3eM0e"};